




















































































































































import Component from 'vue-class-component';
import { Mixins } from 'vue-mixin-decorator';
import { Prop, Watch } from 'vue-property-decorator';
import TabsInfoMixin from './TabsInfoMixin';
import { Global, DeviceStreams } from '@/store';
import MQTT from '@/modules/MQTT';
import Utils from '@/modules/Utils';
import API, { Types } from '@/modules/API';
import OverviewTab from '../information/tondoTabs/OverviewTab.vue';
import ControlTab from '../information/tondoTabs/ControlSliderTab.vue';
import EnergyTab from '../information/tondoTabs/EnergyInfo.vue';
import AdvancedTab from '../information/tondoTabs/AdvancedTab.vue';
import DeviceDataTab from '../information/tondoTabs/DeviceDataTab.vue';
import TemperatureTab from '../information/tondoTabs/TemperatureTab.vue';
import CurveTab from '../information/tondoTabs/CurveTab.vue';
import DaliTab from '../information/tondoTabs/DaliTab.vue';
import mapConfig from '@/pages/mapView/components/map/map.config';
import { RETROFIT_STATE, PARTIAL_RETROFIT_STATE } from '@/modules/retrofitActions';
import {
  fetchFixtureColumns,
  FIXTURE_HEADER_COLUMNS,
  FIXTURE_TAB_COLUMNS,
  FIXTURE_STREAM_COLUMN_NAMES,
  FIXTURE_PROPERTY_COLUMN_NAMES,
  isFixtureTabSnapshotFresh,
  getFixtureTabSnapshot,
  primeFixtureTabSnapshot,
  invalidateFixtureTabCache,
  patchFixtureTabSnapshot,
  fetchDevicePropertyCached
} from '@/views/services/fixtureDetailsApi';

@Component({
  components: {
    OverviewTab,
    ControlTab,
    EnergyTab,
    AdvancedTab,
    DeviceDataTab,
    TemperatureTab,
    CurveTab,
    DaliTab
  }
})
class TondoInfoTabs extends Mixins<TabsInfoMixin>(TabsInfoMixin) {
  @Prop() isContainer;
  @Prop() containers;
  @Prop() container_id;

  @Global.State('lang') lang;
  @Global.State('mqtt_version_by_class') mqtt_version_by_class;
  @DeviceStreams.State('deviceStreams') deviceStreams;
  @DeviceStreams.Mutation('setDeviceStreams') setDeviceStreams;

  mqtt = MQTT.instance;
  streamVersion = null;
  streamPower = null;
  streamPowerObject = {};
  group_ids = [];
  powerMsgSent = false;
  showTemp = false;
  deviceTemp = '';
  statusFromMQTT: string[] = [];
  isDimLevelUpdated = true;
  isDeviceTypeRelay = false;
  metaDeviceData = {};
  loadingTabs = true;
  deviceFixture = null;
  propsList = null;
  percentToDaliTable = {};
  daliToPercentTable = {};
  converted = false;
  tab = 'tab-overview';
  container_devices = [];
  mqtt_subscribe_topic = '';
  mqtt_version = 3;
  daliResponse = '';

  // Accumulator for reporting-query columns fetched lazily per tab. Header
  // (overview) columns are merged in eagerly on device change; other tabs
  // merge their columns on first open. Fields missing here fall back to the
  // device prop (already enriched by the global stream).
  fixtureRow: any = {};
  loadedTabs: Set<string> = new Set();
  loadingTab = false;

  async mounted() {
    if (this.container_id){
      this.updateContainerDevices();
    }
    
    await this.deviceChanged();
  }

  setTabItem(tabIndex) {
    this.tab = tabIndex;
  }

  initMqtt() {
    this.mqtt.init();
    this.listenToMqtt();
  }

  // Devices under Retrofit (or pending verification) don't need a live MQTT
  // subscription until the map's see-through toggle unlocks them.
  mqttConnected = false;

  maybeInitMqtt() {
    if (this.retrofitTabsHidden) {
      this.disconnectMqtt();
      return;
    }
    if (this.mqttConnected) return;
    this.initMqtt();
    this.mqttConnected = true;
  }

  disconnectMqtt() {
    if (this.mqtt_subscribe_topic) {
      this.mqtt.unlisten(this.mqtt_subscribe_topic);
    }
    this.mqttConnected = false;
  }

  @Watch('retrofitTabsHidden')
  onRetrofitTabsHiddenChangeMqtt() {
    if (!this.device) return;
    this.maybeInitMqtt();
  }

  updateMetaDeviceData(meta_device){
    this.metaDeviceData = {...meta_device};
    this.device['meta.device'] = {...meta_device};
    // A save mutates this device's data — drop its cached tab snapshots so a
    // later reopen/revisit re-fetches fresh columns.
    invalidateFixtureTabCache(this.device.id);
    this.fixtureRow['meta.device'] = {...meta_device};
  }

  @Watch('container_id')
  updateContainerDevices(){
    if (this.container_id){
      this.container_devices = [];
      this.container_devices = this.containers[this.container_id];
    }
  }

  @Watch('device')
  async deviceChanged() {
    this.setDeviceStreams([]);
    if (this.mqtt_subscribe_topic){
      this.mqtt.unlisten(this.mqtt_subscribe_topic);
    }
    this.mqtt_subscribe_topic = '';
    try {
      this.powerMsgSent = false;
      this.tab = 'tab-overview';
      this.loadingTabs = true;
      this.clearData();

      // Reset the per-device reporting accumulator + lazy-load bookkeeping.
      this.fixtureRow = {};
      this.loadedTabs = new Set();

      // MQTT version + subscribe topic derive from class_name — no
      // /properties dump needed.
      if (this.mqtt_version_by_class.has(this.device.class_name)) {
        this.mqtt_version = this.mqtt_version_by_class.get(this.device.class_name).mqtt_version;
      }
      this.mqtt_subscribe_topic = this.mqtt.getSingleDeviceSubscribe(this.device.id, this.mqtt_version);

      // Seed metaDeviceData from the device prop (already in the global
      // stream subset) so the header renders before the fetch resolves.
      const metaDevice = this.device['meta.device'];
      if (metaDevice && typeof metaDevice === 'object') {
        this.metaDeviceData = metaDevice;
      }

      // Eager: fetch only the Overview ("full view") columns + groups.
      await this.loadTabData('tab-overview');
      await this.fetchGroups();

      this.mqttConnected = false;
      this.maybeInitMqtt();
      this.loadingTabs = false;
    }
    catch (error) {
      console.log('ERROR while watch device:', error);
      this.loadingTabs = false;
    }
  }

  @Watch('tab')
  async tabChanged() {
    if (!this.device) return;
    this.loadingTabs = true;
    await this.loadTabData(this.tab);
    this.loadingTabs = false;
  }

  /**
   * Fetch (and cache) the reporting columns required by `tabName` in a single
   * streaming_reporting query, then adapt them into the propsList/deviceStreams
   * shapes the child tabs expect. Skips the network on a session re-open or a
   * fresh per-device cache hit (15-min TTL, survives device switches).
   */
  async loadTabData(tabName: string) {
    if (!tabName || this.loadedTabs.has(tabName)) return;

    const columns = tabName === 'tab-overview'
      ? FIXTURE_HEADER_COLUMNS
      : (FIXTURE_TAB_COLUMNS[tabName] || []);

    // Tabs with no reporting columns (device-data: store-only + seeded
    // metaDeviceData; dali: MQTT-only).
    if (!columns.length) {
      this.loadedTabs.add(tabName);
      return;
    }

    // Mark loaded synchronously (before any await) so a concurrent call for
    // the same tab is deduped. On device click both deviceChanged() and the
    // tab watcher (this.tab assignment) target 'tab-overview'; without this
    // guard they fire two identical reporting queries.
    this.loadedTabs.add(tabName);

    // Cache hit — hydrate from the in-memory snapshot, skip the network.
    // Live streams keep updating via MQTT after the cached seed.
    if (isFixtureTabSnapshotFresh(this.device.id, tabName)) {
      const cachedRow = getFixtureTabSnapshot(this.device.id, tabName);
      if (cachedRow) {
        this.fixtureRow = { ...this.fixtureRow, ...cachedRow };
        await this.applyTabSpecificSetup(tabName);
        return;
      }
    }

    this.loadingTab = true;
    try {
      const companyId = this.$store.state.Reports.companyId
        || (this.project && this.project.company)
        || '';
      const projectId = this.$store.state.Reports.projectId
        || (this.project && this.project.id)
        || '';
      const row = await fetchFixtureColumns({
        companyId,
        projectId,
        defaultLocation: this.$store.state.Props.project_default_location,
        id: this.device.id,
        columns
      });
      if (row) {
        this.fixtureRow = { ...this.fixtureRow, ...row };
        await this.applyTabSpecificSetup(tabName);
        primeFixtureTabSnapshot(this.device.id, tabName, row);
      }
    } catch (e) {
      // Allow a later reopen to retry after a failed fetch.
      this.loadedTabs.delete(tabName);
      console.log('ERROR loading tab data:', tabName, e);
    } finally {
      this.loadingTab = false;
    }
  }

  /**
   * Rebuild the propsList + deviceStreams views from the accumulated
   * fixtureRow (falling back to the device prop), then run tab-specific
   * derivations. Keeps the child tab components working unchanged.
   */
  async applyTabSpecificSetup(tabName: string) {
    // propsList.results — property-shaped columns.
    const results: Array<{ name: string; value: any }> = [];
    FIXTURE_PROPERTY_COLUMN_NAMES.forEach((name) => {
      if (name in this.fixtureRow) results.push({ name, value: this.fixtureRow[name] });
      else if (this.device && name in this.device) results.push({ name, value: this.device[name] });
    });
    this.propsList = { results } as any;

    // deviceStreams — stream-shaped columns with last_modified (epoch-seconds).
    const streams: any[] = [];
    FIXTURE_STREAM_COLUMN_NAMES.forEach((name) => {
      let value;
      if (name in this.fixtureRow) value = this.fixtureRow[name];
      else if (this.device && name in this.device) value = this.device[name];
      else return;
      const modified = this.fixtureRow[`${name}__modified`] !== undefined
        ? this.fixtureRow[`${name}__modified`]
        : (this.device ? this.device[`${name}__modified`] : undefined);
      streams.push({ name, id: `${this.device.id}.${name}`, value, last_modified: modified });
    });
    this.setDeviceStreams(streams);

    // device.fixture is eager (header column), so derive it on every setup —
    // the Control tab relies on it being ready without its own fetch.
    const fixture = ('device.fixture' in this.fixtureRow)
      ? this.fixtureRow['device.fixture']
      : (this.device && this.device['device.fixture']);
    if (fixture) {
      this.deviceFixture = fixture;
      this.isDeviceTypeRelay = fixture.type === 'relay';
    }

    if (tabName === 'tab-overview') {
      const powerValue = this.fixtureRow['power'];
      this.streamPowerObject = {
        id: `${this.device.id}.power`,
        name: 'power',
        value: powerValue,
        last_modified: this.fixtureRow['power__modified']
      };
      this.streamPower = Number(powerValue);
      this.streamVersion = this.fixtureRow['version_nrf52840'] || 'N/A';

      await this.setDimmerTables();

      const metaDevice = this.fixtureRow['meta.device'];
      if (metaDevice && typeof metaDevice === 'object') this.metaDeviceData = metaDevice;
    }
  }

  /**
   * device.dimmer_converting_table is fetched on its own via the cached
   * single-property API (15-min TTL) rather than the reporting query.
   */
  async setDimmerTables() {
    const prop = await fetchDevicePropertyCached(this.device.id, 'device.dimmer_converting_table');
    const percentToDaliTable = (prop && prop.value) || null;
    this.percentToDaliTable = percentToDaliTable || {};
    this.daliToPercentTable = {};
    this.converted = false;
    if (percentToDaliTable) {
      Utils.getDaliToPercentTable(percentToDaliTable, this.daliToPercentTable);
      this.converted = true;
    }
  }

  async fetchGroups() {
    try {
      const device_group_ids = await API.get(Types.PROJECTS, `${this.project.id}/devices/${this.device.id}/groups`, {}, {}, 'v4');
      this.group_ids = device_group_ids || [];
    } catch (e) {
      this.group_ids = [];
    }
  }

  get deviceIcon(){
    if (this.device.sys___active === 0) {
      return mapConfig.icons.regularElectricalFault;
    }else if (this.device.sys___active === -1) {
      return mapConfig.icons.regularInMaintenance;
    }else if (this.device.sys___active === -3) {
      return mapConfig.icons.regularInInstallation;
    }else if (this.device.sys___active === -9) {
      return mapConfig.icons.regularInCare;
    }
    else {
      return this.device.power > 0 ? this.device.sys___connected === 0 ? mapConfig.icons.yellowRedLine : mapConfig.icons.regularOn :
        this.device.sys___connected === 0 ? mapConfig.icons.greyRedLine : mapConfig.icons.regularOff;
    } 
  }

  get curveDeviceSchedule() {
    if ('device.schedule' in this.fixtureRow) return this.fixtureRow['device.schedule'];
    return (this.device && this.device['device.schedule']) || null;
  }

  get shouldShowDaliTab() {
    const className = this.device.class_name;
    
    return className && (className === 'NB_BLE_nRF52V2' || className === 'SC220_NEMA' || className === 'SC220_ZHAGA');
  }

  get retrofitStatusLabel() {
    const operation_state = Utils.getOperationState(this.device);

    if (operation_state === RETROFIT_STATE) {
      return 'Retrofit';
    }
    if (operation_state === PARTIAL_RETROFIT_STATE) {
      return 'Partial Retrofit';
    }
    if (Utils.isPendingVerification(this.device)) {
      return 'Pending Verification';
    }

    return '';
  }

  get isRetrofitFixture() {
    return !!this.retrofitStatusLabel;
  }

  // Map-wide "see-through" toggle (GMap.vue toggleRetrofitSeeThrough) -
  // while on, retrofit-hidden tabs/data are unlocked for inspection.
  get retrofitSeeThrough() {
    return this.$store.state.MapSettings.retrofitSeeThrough;
  }

  get retrofitTabsHidden() {
    return this.isRetrofitFixture && !this.retrofitSeeThrough;
  }

  @Watch('retrofitTabsHidden')
  onRetrofitTabsHiddenChange(hidden) {
    if (hidden && ['tab-control', 'tab-energy', 'tab-temperature', 'tab-curve', 'tab-dali'].includes(this.tab)) {
      this.tab = 'tab-overview';
    }
  }

  listenToMqtt() {
    // console.log('Listening to MQTT topic:', this.mqtt_subscribe_topic)
    this.mqtt.listen(this.mqtt_subscribe_topic,
      async (msg, match) => {
        const mqtt_msg_data = this.mqtt.getMqttMsgData(msg, match, this.mqtt_version);
        // console.log('MQTT Message received - stream:', mqtt_msg_data.stream_name, 'type:', mqtt_msg_data.message_type, 'message:', mqtt_msg_data.message);
        if (mqtt_msg_data.device_id === this.device.id){
          // console.log('MQTT Message received - stream:', mqtt_msg_data.stream_name, 'type:', mqtt_msg_data.message_type, 'message:', mqtt_msg_data.message);
          try {
            if (mqtt_msg_data.stream_name === 'command') {
              // console.log('Command stream message:', mqtt_msg_data.message);
              if (mqtt_msg_data.message !== 'AT+m=AT+QTEMP') {
                this.checkCommandMsg(mqtt_msg_data.message);
                this.checkDaliResponse(mqtt_msg_data.message, mqtt_msg_data.message_type);
              }
            }else if (mqtt_msg_data.stream_name === 'power') {
              this.checkPowerMsg(mqtt_msg_data.message, mqtt_msg_data.message_type);
            }
            
            if (mqtt_msg_data.message_type === 'evt' &&
                ((typeof mqtt_msg_data.message === 'string' && 
                  !mqtt_msg_data.message.includes('+QTEMP') &&
                  !mqtt_msg_data.message.includes('+CME ERROR')) || 
                  mqtt_msg_data.format === 'json'
                )
              ) {
                this.setEventsToAdvancedTab(mqtt_msg_data.stream_name, mqtt_msg_data.message);
            }
          } catch (error) {
            console.log(error);
          }
        }
      }
    );
  }

  async checkCommandMsg(message){
    if (typeof message === 'string' && (message.includes('+QTEMP') || message.includes('+CME ERROR'))){
      const date = await this.getTempTime();
      const temp = message.includes('+QTEMP') ? this.parseTemp(message) : 'FAULT'; 
      this.deviceTemp = `Device Temperature: ${temp} c at ${date}`;
      this.showTemp = true;
    }
  }

  checkPowerMsg(message, message_type){
    if (message_type === 'evt'){
      this.isDimLevelUpdated = true;
      this.streamPower = message;
      this.powerMsgSent = false;
      const livePower = {
        power: message,
        power__modified: Math.floor(Date.now() / 1000)
      };
      this.fixtureRow = { ...this.fixtureRow, ...livePower };
      this.streamPowerObject = { ...this.streamPowerObject, value: message, last_modified: livePower.power__modified };
      patchFixtureTabSnapshot(this.device.id, 'tab-overview', livePower);
      // Propagate the new power value to the Vuex device so the map icon
      // recomputes (`Reports/setDeviceField` triggers __iconKey via
      // FIELDS_AFFECTING_ICON). Without this commit, the per-device MQTT
      // topic only updates local component state and the map stays stale.
      this.$store.commit('Reports/setDeviceField', {
        device_id: this.device.id,
        field: 'power',
        value: message
      });
    }else {
      this.powerMsgSent = true;
    }
  }

  setEventsToAdvancedTab(streamName, message){
    console.log(
      '%c' + 'ADVANCED TAB - MQTT MESSAGE:' + message,
      'background: #222; color: #bada15'
    );
    const final_message = `${streamName}: ${message}`;
    this.statusFromMQTT.push(final_message);
  }

  mqttGetMsg(format, message) { 
    return format === 'minimal' ? Number(message) : Number(message['content']);
  }

  parseTemp(message) {
    const startIndex = message.indexOf(',');
    const endIndex = message.slice(startIndex + 1).indexOf(',');
    return message.slice(startIndex + 1, startIndex + endIndex + 1);
  }

  async getTempTime() {
    const response = await API.get(
      Types.DEVICES,
      `${this.device.id}/streams/${this.device.id}.command/latest/`);
    const date = new Date(response['timestamp']);
    return Utils.getDateString(date);
  }

  containerDeviceClicked(device){
    this.mqtt.unlisten(this.mqtt_subscribe_topic);
    this.$emit('deviceChanged', device);
  }

  updateDim(value = false) {
    this.isDimLevelUpdated = value;
  }

  checkDaliResponse(message, message_type) {
    // console.log('DALI Response - message:', message, 'message_type:', message_type);
    if (message_type === 'evt') {
      // Convert message to string if it's a number
      const messageStr = typeof message === 'number' ? String(message) : message;
      
      // Check if this is a DALI response
      if (typeof messageStr === 'string') {
        if (messageStr === 'OK' || messageStr === 'ERROR' || 
            (messageStr.length > 0 && !messageStr.includes('+QTEMP') && !messageStr.includes('+CME ERROR'))) {
          // console.log('Setting daliResponse to:', messageStr);
          // Update daliResponse to trigger watcher in DaliTab
          this.daliResponse = messageStr;
          // Reset after a delay to allow for new responses
          setTimeout(() => {
            // console.log('Resetting daliResponse');
            this.daliResponse = '';
          }, 500);
        }
      }
    }
  }

  sendDaliCommand(command: string) {
    const mqtt_publish_data = {
      message_type: 'cmd',
      format: 'minimal',
      stream_value: command,
      options: {
        retain: false,
        qos: 1
      },
      version_num: this.mqtt_version,
      device_id: this.device.id,
      stream_id: this.mqtt_version === 3 ? `${this.device.id}.command` : 'command'
    };
    // console.log('Sending DALI command:', command)

    this.mqtt.publishToSingleDevice(mqtt_publish_data);
    // console.log('Published DALI command:', mqtt_publish_data)
  }

  clearData() {
    this.isDeviceTypeRelay = false;
    this.metaDeviceData = {};
    this.statusFromMQTT = [];
    this.deviceTemp = '';
    this.showTemp = false;
    this.daliResponse = '';
  }

  beforeDestroy() {
    this.setDeviceStreams([]);
    this.mqtt.unlisten(this.mqtt_subscribe_topic);
  }
}

export default TondoInfoTabs;
